export default __webpack_public_path__ + "static/media/logo-cs.9a3fb81b.svg";